<div class="adesao-log-dialog__overlay" (click)="onFechar()">
  <div
    class="adesao-log-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="adesao-log-dialog-title"
    data-testid="adesao-log-dialog"
    (click)="$event.stopPropagation()"
  >
    <h2 id="adesao-log-dialog-title" class="adesao-log-dialog__title">Log do participante</h2>
    <p class="adesao-log-dialog__participante" data-testid="adesao-log-dialog-nome">
      {{ log().nome }}
    </p>

    @if (log().entradas.length === 0) {
      <p class="adesao-log-dialog__vazio" data-testid="adesao-log-dialog-vazio">
        Nenhum registro de log para este participante.
      </p>
    } @else {
      <app-data-table ariaLabel="Histórico da adesão do participante">
        <thead>
          <tr>
            <th scope="col">Data/Hora</th>
            <th scope="col">Data integração</th>
            <th scope="col">Status</th>
            <th scope="col">Mensagem</th>
          </tr>
        </thead>
        <tbody>
          @for (entrada of log().entradas; track $index) {
            <tr>
              <td data-testid="adesao-log-data-hora">{{ entrada.dataHora }}</td>
              <td data-testid="adesao-log-data-integracao">{{ entrada.dataIntegracao ?? '—' }}</td>
              <td><app-status-badge [status]="entrada.status" /></td>
              <td data-testid="adesao-log-mensagem">{{ entrada.mensagem }}</td>
            </tr>
          }
        </tbody>
      </app-data-table>
    }

    <div class="adesao-log-dialog__actions">
      <button
        type="button"
        class="btn-primary"
        data-testid="adesao-log-dialog-fechar"
        (click)="onFechar()"
      >
        Fechar
      </button>
    </div>
  </div>
</div>
